"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetLineItemsTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var currenciesList_1 = require("common/global/currenciesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var app_1 = __importDefault(require("firebase/app"));
var lodash_1 = require("lodash");
var useMemoIfNotUndefined_1 = require("portal/hooks/useMemoIfNotUndefined");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var formatNumber_1 = __importDefault(require("portal/utils/formatNumber"));
var react_1 = __importStar(require("react"));
var auth_1 = require("react-firebase-hooks/auth");
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var use_react_router_1 = __importDefault(require("use-react-router"));
var AddProcurementPlanItem_1 = __importDefault(require("../Dialogs/AddProcurementPlanItem"));
var moment_1 = __importDefault(require("moment"));
var react_router_dom_1 = require("react-router-dom");
var Option = antd_1.Select.Option;
var BudgetLineItemsTable = function (props) {
    var _a, _b;
    var user = (0, auth_1.useAuthState)(app_1.default.auth())[0];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, react_1.useState)(false), modalState = _c[0], setModalState = _c[1];
    var history = (0, use_react_router_1.default)().history;
    var budgetLineId = props.budgetLineId, budgetSectionId = props.budgetSectionId, index = props.index, code = props.code, projectId = props.projectId;
    var _d = (0, react_1.useState)([]), selectedRowKeys = _d[0], setSelectedRowKeys = _d[1];
    var _e = (0, react_1.useState)(""), editingKey = _e[0], setEditingKey = _e[1];
    var _f = (0, react_1.useState)({}), editingState = _f[0], setEditingState = _f[1];
    var _g = (0, react_1.useState)(false), isAdding = _g[0], setIsAdding = _g[1];
    var _h = (0, react_1.useState)(""), docId = _h[0], setDocId = _h[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var project = projectsList_1.globalProjectsData[projectId];
    var projectStatus = (project === null || project === void 0 ? void 0 : project.status) || "planning";
    var projectCurrency = (_b = (_a = currenciesList_1.globalCurrenciesData[project === null || project === void 0 ? void 0 : project.currencyId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    var budgetLineItemsSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.budgetLineItemsRef
        .where("projectId", "==", projectId)
        .where("budgetLineId", "==", budgetLineId))[0];
    var budgetLineSn = (0, firestore_1.useDocument)(collectionsRef_1.budgetLinesRef.doc(props.budgetLineId))[0];
    var budgetLineData = budgetLineSn === null || budgetLineSn === void 0 ? void 0 : budgetLineSn.data();
    var budgetLineItems = (0, react_1.useMemo)(function () {
        var _a;
        return (0, lodash_1.sortBy)((_a = budgetLineItemsSnapshot === null || budgetLineItemsSnapshot === void 0 ? void 0 : budgetLineItemsSnapshot.docs) === null || _a === void 0 ? void 0 : _a.map(function (e) {
            return __assign(__assign({}, e.data()), { id: e.id });
        }), function (item) { return (0, moment_1.default)(item.createdAt).toDate(); });
    }, [budgetLineItemsSnapshot]);
    var totalBudgetLineItems = (0, formatNumber_1.default)((0, lodash_1.sum)(budgetLineItems.map(function (e) { return e.total; })));
    if (!budgetLineItemsSnapshot || !budgetLineSn) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var isEditing = function (record) {
        return record.id === editingKey;
    };
    var save = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        var newData, totalLineItem, id, totalBudgetLineItems, totalBudgetLineRow, sectionTotal, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newData = __assign(__assign({}, record), editingState);
                    totalLineItem = parseFloat(newData.quantity + "") * parseFloat(newData.unitCost + "");
                    id = newData.id === "newDoc" ? collectionsRef_1.budgetLineItemsRef.doc().id : newData.id;
                    return [4 /*yield*/, collectionsRef_1.budgetLineItemsRef.doc(id).set({
                            projectId: newData.projectId,
                            budgetSectionId: budgetLineData.budgetSectionId,
                            budgetLineId: newData.budgetLineId,
                            code: newData.code,
                            productId: newData.productId,
                            productName: newData.productName,
                            productDescription: newData.productDescription,
                            productType: newData.productType,
                            productUnitId: newData.productUnitId,
                            quantity: newData.quantity,
                            unitCost: newData.unitCost,
                            total: totalLineItem,
                            createdAt: newData.createdAt,
                        })];
                case 1:
                    _b.sent();
                    totalBudgetLineItems = (0, lodash_1.sum)(budgetLineItems.filter(function (x) { return x.id !== id; }).map(function (e) { return e.total; })) +
                        totalLineItem;
                    totalBudgetLineRow = budgetLineData
                        ? totalBudgetLineItems *
                            budgetLineData.quantity *
                            (budgetLineData.allocation / 100) *
                            budgetLineData.durationRecurrence
                        : 0;
                    return [4 /*yield*/, budgetLineSn.ref.update({
                            unitCost: totalBudgetLineItems,
                            total: totalBudgetLineRow,
                        })];
                case 2:
                    _b.sent();
                    setEditingKey("");
                    setIsAdding(false);
                    _a = lodash_1.sumBy;
                    return [4 /*yield*/, collectionsRef_1.budgetLinesRef
                            .where("budgetSectionId", "==", budgetSectionId)
                            .get()];
                case 3:
                    sectionTotal = _a.apply(void 0, [(_b.sent()).docs,
                        function (x) { return x.data().total; }]);
                    return [4 /*yield*/, collectionsRef_1.budgetSectionsRef.doc().update({
                            total: sectionTotal,
                        })];
                case 4:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var edit = function (key) {
        setEditingKey(key);
    };
    var columnsBudgetLineItems = __spreadArray([
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
            editable: true,
        },
        {
            title: "Product Name",
            dataIndex: "productId",
            key: "productId",
            editable: true,
            render: function (_, record) { return record.productName; },
        },
        {
            title: "Unit",
            dataIndex: "productUnitId",
            key: "productUnitId",
            editable: false,
            render: function (productUnitId) { var _a; return (_a = unitsList_1.globalUnitsData[productUnitId]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            editable: true,
        },
        {
            title: "Unit Cost",
            dataIndex: "unitCost",
            key: "unitCost",
            editable: true,
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            editable: true,
            render: function (total) { return (0, formatNumber_1.default)(total); },
        },
        {
            title: "operation",
            dataIndex: "operation",
            render: function (_, record) {
                var editable = isEditing(record);
                return editable ? ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link", onClick: function () {
                                save(record);
                            }, style: { marginRight: 8 } }, { children: "Save" })), (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Sure to cancel?", onConfirm: function () {
                                setEditingKey("");
                                setIsAdding(false);
                            } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link" }, { children: "Cancel" })) }))] })) : projectStatus === "running" ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link", onClick: function () {
                        setDocId(record.id);
                        setModalState(true);
                    } }, { children: t("budget.addToPlan") }))) : ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link", disabled: projectStatus != "planning", onClick: function () {
                        edit(record.id);
                        setEditingState({});
                    } }, { children: "Edit" })));
            },
        }
    ], (projectStatus === "planning"
        ? []
        : [
            {
                title: "Max Quantity/ Planned",
                dataIndex: "maxQuantity",
                key: "maxQuantity",
                editable: false,
                render: function (maxQuantity, record) {
                    return "".concat(maxQuantity, "/").concat(record.plannedQuantity);
                },
            },
        ]), true);
    var columns = columnsBudgetLineItems.map(function (col) {
        if (!col.editable) {
            return col;
        }
        return __assign(__assign({}, col), { onCell: function (record) {
                var editing = isEditing(record);
                var finalData = editing ? __assign(__assign({}, record), editingState) : record;
                var recordValue = finalData[col.dataIndex];
                if (col.dataIndex === "total") {
                    recordValue = (0, formatNumber_1.default)(parseFloat(finalData.quantity + "") *
                        parseFloat(finalData.unitCost + ""));
                    editing = false;
                }
                var inputType = {
                    index: "index",
                    productId: "productSelect",
                    total: "number",
                    unitCost: "number",
                    quantity: "number",
                };
                return {
                    record: record,
                    inputType: inputType[col.dataIndex] || "text",
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: editing,
                    value: recordValue,
                    onChangeText: function (newValue) {
                        var _a;
                        setEditingState(__assign(__assign({}, editingState), (_a = {}, _a[col.dataIndex] = newValue, _a)));
                    },
                    onChangeRecord: function (newRecord) {
                        setEditingState(__assign(__assign({}, editingState), newRecord));
                    },
                };
            } });
    });
    var deleteBudgetLine = function () {
        selectedRowKeys.forEach(function (docId) {
            collectionsRef_1.budgetLineItemsRef
                .doc(docId)
                .delete()
                .then(function () {
                setSelectedRowKeys([]);
            });
        });
    };
    var handleAdd = function () {
        var budgetLineItemId = "newDoc";
        var newObj = {
            id: budgetLineItemId,
            budgetSectionId: budgetSectionId,
            budgetLineId: props.budgetLineId,
            code: "",
            productId: "",
            productName: "",
            productUnitId: "",
            productType: "consumable",
            projectId: projectId,
            quantity: 0,
            unitCost: 0,
            total: 0,
            maxQuantity: 0,
            plannedQuantity: 0,
            createdAt: new Date(),
        };
        setEditingState(newObj);
        setIsAdding(true);
        edit(budgetLineItemId);
    };
    var hasSelected = selectedRowKeys.length > 0;
    var dataSource = isAdding
        ? __spreadArray(__spreadArray([], budgetLineItems, true), [editingState], false) : budgetLineItems;
    function InsertIRItems() {
        return __awaiter(this, void 0, void 0, function () {
            var IRId, orderCreate;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        IRId = collectionsRef_1.IRsRef.doc().id;
                        return [4 /*yield*/, collectionsRef_1.ordersRef.add({
                                projectId: projectId,
                                status: "preparingIR",
                                IRId: IRId,
                                createdAt: new Date(),
                            })];
                    case 1:
                        orderCreate = _a.sent();
                        return [4 /*yield*/, collectionsRef_1.IRsRef.doc(IRId).set({
                                orderId: orderCreate.id,
                                initiatedBy: user.uid,
                                status: "draft",
                                projectId: projectId,
                                createdAt: new Date(),
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(budgetLineItems.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (!selectedRowKeys.includes(item.id)) {
                                        return [2 /*return*/];
                                    }
                                    return [2 /*return*/, collectionsRef_1.IRItemsRef.add({
                                            IRId: IRId,
                                            productId: item.productId,
                                            productName: item.productName,
                                            productDescription: item.productDescription,
                                            quantity: item.quantity,
                                            estimatedPrice: item.unitCost,
                                            budgetLineId: item.budgetLineId,
                                            budgetLineItemId: item.id,
                                            createdAt: new Date(),
                                        })];
                                });
                            }); }))];
                    case 3:
                        _a.sent();
                        navigate("/internal-requests/".concat(IRId));
                        return [2 /*return*/];
                }
            });
        });
    }
    var totalBudgetLinesItems = "Total Items:  ".concat(totalBudgetLineItems, " ").concat(projectCurrency);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [modalState ? ((0, jsx_runtime_1.jsx)(AddProcurementPlanItem_1.default, { projectId: projectId, modalState: modalState, setModalState: setModalState, docId: docId })) : null, (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginBottom: 25 } }, { children: projectStatus === "running" &&
                    (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["IRCreate"]) ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.buttonsGroup }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: InsertIRItems, disabled: !hasSelected }, { children: t("budget.createIR") })), (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginLeft: 8 } }, { children: hasSelected ? "Selected ".concat(selectedRowKeys.length, " items") : "" }))] }))) : null })), (0, jsx_runtime_1.jsx)(antd_1.Table, { rowKey: "id", columns: columns, components: {
                    body: {
                        cell: EditableCell,
                    },
                }, dataSource: dataSource, rowSelection: {
                    onChange: function (selectedRow, selectedRows) {
                        setSelectedRowKeys(selectedRows.map(function (x) { return x.id; }));
                    },
                }, pagination: false, size: "small", footer: function () { return ((0, jsx_runtime_1.jsx)("h3", __assign({ style: { padding: 20, borderRadius: 5 } }, { children: (0, jsx_runtime_1.jsx)("b", __assign({ style: { float: "right", color: "#558690", fontSize: 13 } }, { children: totalBudgetLinesItems })) }))); } }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginBottom: 16 } }, { children: projectStatus === "planning" ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.buttonsGroup }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: handleAdd }, { children: t("budget.addNewItem") })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: deleteBudgetLine, disabled: !hasSelected }, { children: t("budget.delete") })), (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginLeft: 8 } }, { children: hasSelected ? "Selected ".concat(selectedRowKeys.length, " items") : "" }))] }))) : null }))] }));
};
exports.BudgetLineItemsTable = BudgetLineItemsTable;
var EditableCell = function (props) {
    var _a;
    var _b = (0, react_1.useState)(""), productSearch = _b[0], setProductSearch = _b[1];
    var trueStatus = true;
    var productsSnapshotFromFirebase = (0, firestore_1.useCollection)(collectionsRef_1.productsRef
        .where("nameIndex", "array-contains", productSearch.toLowerCase().trim())
        .where("active", "==", trueStatus)
        .limit(9))[0];
    var productsSnapshot = (0, useMemoIfNotUndefined_1.useMemoIfNotUndefined)(productsSnapshotFromFirebase);
    var data = (_a = productsSnapshot === null || productsSnapshot === void 0 ? void 0 : productsSnapshot.docs) === null || _a === void 0 ? void 0 : _a.map(function (product, idx) {
        var _a, _b;
        return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: product.id }, { children: "".concat((_a = product.data()) === null || _a === void 0 ? void 0 : _a.name, " / ").concat((_b = product.data()) === null || _b === void 0 ? void 0 : _b.description) }), idx));
    });
    var editing = props.editing, dataIndex = props.dataIndex, inputType = props.inputType, record = props.record, value = props.value, children = props.children, restProps = __rest(props, ["editing", "dataIndex", "inputType", "record", "value", "children"]);
    var getInput = function () {
        switch (inputType) {
            case "productSelect": {
                return ((0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "100%", marginLeft: "1%" }, showSearch: true, value: props.value, onSearch: function (e) { return setProductSearch(e); }, optionFilterProp: "children", onChange: function (e) {
                        var _a, _b;
                        var product = (_b = (_a = productsSnapshot === null || productsSnapshot === void 0 ? void 0 : productsSnapshot.docs) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.id === e; })) === null || _b === void 0 ? void 0 : _b.data();
                        props.onChangeRecord({
                            productName: product === null || product === void 0 ? void 0 : product.name,
                            productDescription: product === null || product === void 0 ? void 0 : product.description,
                            productId: e,
                            productType: product === null || product === void 0 ? void 0 : product.productType,
                            productUnitId: product === null || product === void 0 ? void 0 : product.unitId,
                        });
                    } }, { children: data })));
            }
            case "number": {
                return ((0, jsx_runtime_1.jsx)(antd_1.InputNumber, { min: 0, type: "number", value: props.value, onChange: function (e) { return props.onChangeText(e); } }));
            }
        }
        return ((0, jsx_runtime_1.jsx)(antd_1.Input, { value: value, onChange: function (e) { return props.onChangeText(e.target.value); } }));
    };
    return ((0, jsx_runtime_1.jsx)("td", __assign({}, restProps, { children: editing ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ style: { margin: 0 } }, { children: getInput() }))) : dataIndex === "productId" ? (children) : (value !== null && value !== void 0 ? value : children) })));
};
